import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { API_BASE_URL } from 'src/app/core/providers/constants/api.constants';
import { Certificate } from '../types/certificate';

@Injectable({ providedIn: 'root' })
export class ApiRouteCertificateService {
  urlRoute = `${API_BASE_URL}/certificates`;
  http = inject(HttpClient);
  constructor() {}
  getCertificates(): Observable<Certificate[]> {
    return this.http.get<Certificate[]>(this.urlRoute);
  }
}
